import { compose, withProps } from 'recompose'
import isNumber from 'lodash/isNumber'

const buildData = slices => {
  let cumulative = 0

  return slices.map(slice => {
    const start = cumulative
    const value = isNumber(slice.value) ? slice.value : 0
    cumulative += value

    return {
      ...slice,
      value,
      start,
    }
  })
}

const PieChartContainer = compose(
  withProps(({ slices }) => ({
    slices: buildData(slices),
  }))
)

export default PieChartContainer
